import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "ticketino-api-client";
import { useLanguage } from "../hooks/useLanguage";
import { useOrder } from "../hooks/useOrder";

import Header from "./components/Header";
import Footer from "./components/Footer";

import infoIconWhite from '../images/icons/info-white.svg';

import wowGoodieBagImg from '../images/addons/addon-birthday-goodie-bag.png';
import wowBlackTapImg from '../images/addons/addon-birthday-blacktap.png';
import raumVisAVisImg from '../images/addons/addon-vis-a-vis.png';

const Addons_RallyBirthday = () => {
    const AddOnsConfig = {
        giftGoodieBag: {
            quantity: 60,
            price: 10.00,
            externalTicketCode: "bday addon goodie bag",
            image: wowGoodieBagImg,
        },
        blackTapMilkshake: {
            image: wowBlackTapImg,
        },
        raumVisAVis: {
            options: [
                {
                    label: "Kurzmiete",
                    price: 150.00,
                    externalTicketCode: "bday addon raum kurzmiete"
                },
            ],
            image: raumVisAVisImg,
        },
    }

    const [resources, setResources] = useState({});
    const [hasBlackTapMilkshake, setHasBlackTapMilkshake] = useState("");
    const [quantities, setQuantities] = useState({});
    const [raumVisAVisSelected, setRaumVisAVisSelected] = useState("");

    let navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const { language } = useLanguage();
    const order = useOrder(baseUrl);

    useEffect(() => {
        document.body.classList.remove('no-scroll');
    }, []);

    useEffect(() => {
        if (language) {
            requestResources();
        }
    }, [language]);

    useEffect(() => {
        if (resources?._No && !hasBlackTapMilkshake) {
            setHasBlackTapMilkshake(resources._No);
        }
    }, [resources]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const handleQuantityChange = (externalTicketCode, value) => {
        setQuantities(prev => ({ ...prev, [externalTicketCode]: value }));
    };

    const handleRaumVisAVisDropdown = (value) => {
        setRaumVisAVisSelected(value);
        if (value && resources?._No) {
            setHasBlackTapMilkshake(resources._No);
        }
    };

    const handleBlackTapDropdown = (value) => {
        setHasBlackTapMilkshake(value);
        if (value === resources?._Yes) {
            setRaumVisAVisSelected("");
        }
    };

    const handleNext = () => {
        const selectedTickets = [];

        if (raumVisAVisSelected) {
            selectedTickets.push({ externalTicketCode: raumVisAVisSelected, quantity: 1 });
        }

        Object.entries(quantities).forEach(([externalTicketCode, quantity]) => {
            if (quantity > 0) {
                selectedTickets.push({ externalTicketCode, quantity });
            }
        });

        localStorage.setItem("hasBlackTapMilkshake", hasBlackTapMilkshake);

        if (selectedTickets.length === 0) {
            localStorage.removeItem('selectedTicketsAddons');
        } else {
            localStorage.setItem('selectedTicketsAddons', JSON.stringify({
                eventGroupId: 3553,
                tickets: selectedTickets
            }));
        }

        navigate(`/${language}/calendar-rally`);
    };

    return (
        <>
            <Header language={language} pagePath="addons-rally-birthday" pageTitle={resources?.AddOnsTitle}
                ticketCount={order?.tickets?.length || 0} />

            <div className="page-container">
                <div className="container wrapper">

                    <div className="row mt-2">
                        <p><strong>Specials</strong></p>
                    </div>

                    <table className="table table-no-border table-align-middle" style={{ marginBottom: 0, width: "100%" }}>
                        <tbody>
                            {/* WOW Goodie bag */}
                            <tr>
                                <td colSpan={2} style={{ padding: 0, border: 'none' }}>
                                    <div className="goodie-card">
                                        <div className="goodie-card-image">
                                            <img src={AddOnsConfig.giftGoodieBag.image} alt="Goodie bag" />
                                        </div>
                                        <div className="goodie-card-content">
                                            <div className="fw-bold">{resources?.AddOnsGoodieBag}</div>
                                            <div>{resources?.AddOnsGoodieBagDesc}</div>
                                            <div className="mt-3">CHF {AddOnsConfig.giftGoodieBag.price.toFixed(2)}</div>
                                            <div className="goodie-select mt-3">
                                                <select
                                                    className="form-select qtd-select"
                                                    style={{ minWidth: 120, backgroundColor: "#fff" }}
                                                    onChange={e => handleQuantityChange(AddOnsConfig.giftGoodieBag.externalTicketCode, Number(e.target.value))}
                                                >
                                                    {[...Array(AddOnsConfig.giftGoodieBag.quantity + 1).keys()].map(qty => (
                                                        <option key={qty} value={qty}>{qty}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {/* Black Tap Milkshake reservation */}
                            <tr>
                                <td colSpan={2} style={{ padding: 0, border: 'none' }}>
                                    <div className="goodie-card">
                                        <div className="goodie-card-image">
                                            <img src={AddOnsConfig.blackTapMilkshake.image} alt="Black tap reservation" />
                                        </div>
                                        <div className="goodie-card-content">
                                            <div className="fw-bold">{resources?.AddOnsGiftBlackTap}</div>
                                            <div>{resources?.AddOnsGiftBlackTapDesc}</div>
                                            <div className="goodie-select mt-3">
                                                <select
                                                    className="form-select qtd-select"
                                                    style={{ minWidth: 120, backgroundColor: "#fff" }}
                                                    value={hasBlackTapMilkshake}
                                                    onChange={e => handleBlackTapDropdown(e.target.value)}
                                                    disabled={raumVisAVisSelected !== ""}
                                                >
                                                    <option value={resources?._No}>{resources?._No}</option>
                                                    <option value={resources?._Yes}>{resources?._Yes}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {/* Raum vis a vis */}
                            <tr>
                                <td colSpan={2} style={{ padding: 0, border: 'none' }}>
                                    <div className="goodie-card">
                                        <div className="goodie-card-image">
                                            <img src={AddOnsConfig.raumVisAVis.image} alt="Raum vis a vis" />
                                        </div>
                                        <div className="goodie-card-content">
                                            <div className="fw-bold">{resources?.AddOnsGiftRaumVisAVis}</div>
                                            <div className="ps-md-4 pe-md-4 text-center" dangerouslySetInnerHTML={{ __html: resources?.AddOnsGiftRaumVisAVisDesc }}></div>
                                            <div className="mt-3">
                                                {raumVisAVisSelected && (
                                                    <span>
                                                        CHF {AddOnsConfig.raumVisAVis.options.find(opt => opt.externalTicketCode === raumVisAVisSelected)?.price.toFixed(2)}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="goodie-select mt-3">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                    <select
                                                        className="ms-md-4 form-select qtd-select"
                                                        style={{ minWidth: 120, backgroundColor: "#fff" }}
                                                        value={raumVisAVisSelected}
                                                        onChange={e => handleRaumVisAVisDropdown(e.target.value)}
                                                        disabled={hasBlackTapMilkshake === resources?._Yes}
                                                    >
                                                        <option value=""></option>
                                                        {AddOnsConfig.raumVisAVis.options.map(option => (
                                                            <option key={option.externalTicketCode} value={option.externalTicketCode}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className="info-icon-wrapper">
                                                        <img src={infoIconWhite} alt="Info" className="info-icon" style={{ marginLeft: 0 }} />
                                                        <span className="tooltip">
                                                            {resources?.AddOnsRaumVisAVisToolTip}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="row mt-5">
                        <div className="col-6">
                            <button
                                className="btn-custom white"
                                type="submit"
                                onClick={() => navigate(-1)}
                            >
                                {resources?._Back}
                            </button>
                        </div>

                        <div className="col-6 text-end">
                            <button
                                className="btn-custom"
                                type="submit"
                                onClick={handleNext}
                            >
                                {resources?._Next}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Footer language={language} />
        </>
    )
}

export default Addons_RallyBirthday
